import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-background px-5 pb-12 pt-[15px] sm:pb-20 sm:pt-10" data-id="element-112" data-mp="9l33995lu62e">
      <div className="mx-auto max-w-4xl text-center" data-id="element-113" data-mp="4na0yr7f9w7e">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="eyebrow-rule text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-secondary sm:text-xs sm:tracking-[0.22em]" data-id="element-114" data-mp="12a0mbehn46w7">
          Il curriculum di matematica completo per docenti italiani
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: EASE
      }} className="mt-3 font-display text-[2.25rem] font-black leading-[1.06] tracking-tight text-foreground sm:mt-5 sm:text-[3.4rem] md:text-[4rem]" data-id="element-115" data-mp="3d1sbr0oqzpup">
          Risolvi un Intero Anno di Lezioni di Matematica in soli{' '}
          <span className="italic text-primary" data-id="element-116" data-mp="399te53cn8qcv">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: EASE
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-foreground/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-117" data-mp="3e8ehvcr3ts62">
          <span className="sm:hidden" data-id="element-118" data-mp="2qlof296xltke">
            8 volumi PDF pronti all&apos;uso, dalla 1ª Primaria alla 3ª Media.
            Stampa, apri e insegna.
          </span>
          <span className="hidden sm:inline" data-id="element-119" data-mp="2hk886bfbs9kx">
            Matematica Pronta è il sistema completo «chiavi in mano»: 8 volumi
            PDF pronti all&apos;uso carichi di teoria visuale, attività
            operative, esercizi e verifiche dalla 1ª Primaria alla 3ª Media.
            Basta stampare, aprire e insegnare.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.15,
        ease: EASE
      }} className="mx-auto mt-3 max-w-2xl sm:mt-10" data-id="element-120" data-mp="ic89fikzqczf">
          <img src="https://cdn.magicpatterns.com/uploads/75eENhcjp7iSxQxQ1ZswqE/Pack_educativo_Matematica_Pronta_para_docentes.webp" alt="Il pacchetto Matematica Pronta: 8 volumi stampati, la versione digitale su computer e tablet e i 5 bonus" className="mx-auto max-h-[34vh] w-full object-contain sm:max-h-none" data-id="element-121" data-mp="1b049mx9rqn0y" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: EASE
      }} className="mt-3 sm:mt-8" data-id="element-122" data-mp="3lsp3vew9yley">
          <CtaButton label="Ottieni il pacchetto Matematica Pronta" href="#offerta" data-id="element-123" data-mp="1xam4qoj23mxv" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-foreground/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-124" data-mp="21by0lbsix4ei">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-125" data-mp="2b1hh4asrkm67" data-mpi={index}>
                <span className="inline-flex items-center gap-1" data-id="element-126" data-mp="2g0lr33niinxl">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-secondary" aria-hidden="true" data-id="element-127" data-mp="2kyvm9e98loj7" />
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-foreground/25" data-id="element-128" data-mp="2oyebgm83clru">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}